import { COLORS } from "components/consts";

export const TOOLTIP_STYLES = {
  bgcolor: COLORS.Romance,
  color: "#fff",
  borderRadius: "10px",
  p: "12px 14px",
  maxWidth: "calc(100vw - 32px)",
  boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
  fontSize: "12.5px",
  lineHeight: 1.5,
  fontWeight: 400,
  textAlign: "left",
  textTransform: "none",
  letterSpacing: "normal",
};

export const TOOLTIP_TITLE_STYLES = {
  fontSize: "13px",
  fontWeight: 600,
  mb: 0.5,
};

export const TOOLTIP_TEXT_STYLES = {
  fontSize: "12.5px",
  lineHeight: 1.5,
  width: "320px",
};

export const INFO_ICON_STYLES = {
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  width: 12,
  height: 12,
};
